import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import { TranslationService } from '../../../core/i18n/translation.service';

@Component({
  selector: 'app-checklist-item-definition-yes-no',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './checklist-item-definition-yes-no.component.html',
  styleUrl: './checklist-item-definition.shared.css',
})
export class ChecklistItemDefinitionYesNoComponent {
  readonly form = input.required<FormGroup>();
  readonly i18n = input.required<TranslationService>();
}
